(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('FormulaDetailController', FormulaDetailController);

    FormulaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'FormulaService', 'FormulaCustomService', 'ToastrService'];

    function FormulaDetailController($scope, $rootScope, $stateParams, previousState, entity, FormulaService, FormulaCustomService, ToastrService ) {
        var vm = this;

        vm.formula = entity;
        vm.mode = 0;
        vm.sampleWeight = 1;
        vm.sampleBale = 1;
        vm.resultWeight = 0;
        vm.resultBale = 0;
        vm.previousState = previousState.name;
        figureThingsOut();

        vm.sampleComputation = sampleComputation;
        vm.onTextClick = onTextClick;

        function figureThingsOut() {
            if( vm.formula.type == "weight" ) {
                vm.mode = 0;
            } else {
                if( vm.formula.parentString == null ) {
                    vm.mode = 2;
                } else {
                    vm.mode = 1;
                }
            }
            sampleComputation();
        }

        function sampleComputation() {
            switch( vm.mode ) {
                case 0:
                    FormulaCustomService.sampleComputationString( vm.formula.rate, vm.sampleWeight, "weight" ).then( function( data ) {
                        vm.resultWeight = data.data;
                    }, function( error ) {
                        if( error.status !== "404" ) {
                            ToastrService.error( "Failed to get computation", "Error");
                        }
                        console.log( error.message );
                    });
                    break;
                case 1:
                    FormulaCustomService.sampleComputationString( vm.formula.rate, vm.sampleWeight, "growth" ).then( function( data ) {
                        vm.resultBale = data.data;
                    }, function( error ) {
                        if( error.status !== "404" ) {
                            ToastrService.error( "Failed to get computation", "Error" );
                        }
                        console.log( error.message );
                    });
                    break;
                case 2:
                    FormulaCustomService.sampleComputationString( vm.formula.rate, vm.sampleBale, "weight" ).then( function( data ) {
                        vm.resultWeight = data.data;
                    }, function( error ) {
                        if( error.status !== "404" ) {
                            ToastrService.error( "Failed to get computation", "Error" );
                        }
                        console.log( error.message );
                    });
                    break;
            }
        }

        function onTextClick( $event ) {
            $event.target.select();
        }

        var unsubscribe = $rootScope.$on('ccsTrApp:formulaUpdate', function(event, result) {
            vm.formula = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
